import Block from '@/components/Block'
import { Stack } from '@/components/Layout'
import { coreLayoutContainer, coreLayoutSection } from '@/constants/measured-scope'
import { useFeatureToggle } from '@/context/featureToggles'
import Search from '@/widgets/AI/Search'
import * as styles from './style'

export interface Props {
  id: string
  partnerId?: string
}

const HelenSearchBlock = (props: Props): JSX.Element => {
  const showHelenTab = useFeatureToggle('helen_tab')

  if (!showHelenTab) return <></>
  return (
    <Block key={props.id} id={props.id} className={`${coreLayoutSection}  ${styles.root}`} spacing="sm">
      <Stack x className={`${coreLayoutContainer}`} alignItems="center" justifyContent="center">
        <Search mode="WIDGET" partnerId={props.partnerId} />
      </Stack>
    </Block>
  )
}

export default HelenSearchBlock
